import { Box, Button, Modal, Tooltip } from '@mui/material'
import { DEFAULT_WARNING_DESCRIPTION } from 'atoms/IaCComponentReferenceWarning/IaCComponentReferenceWarning'
import { InstallationDetail } from 'common/types/kraken-core/Installation'
import { IntegrationModule } from 'common/types/kraken-core/IntegrationModule'
import IntegrationModuleEditWizard from 'pages/IntegrationModules/IntegrationModuleEditWizard'
import { useState } from 'react'
import { toast } from 'react-toastify'

export interface InstallationEditActionProps {
  installation: InstallationDetail
  integrationModule: IntegrationModule
  onInstallationUpdated: (installation: InstallationDetail) => void
}

const SELF_SERVICE = 'self_service'

export default function InstallationEditAction({
  installation,
  integrationModule,
  onInstallationUpdated,
}: InstallationEditActionProps) {
  const [editModalOpen, setEditModalOpen] = useState(false)

  const isSelfService = installation.installation_type === SELF_SERVICE
  const canEdit = isSelfService

  const tooltipTitle = canEdit ? 'Edit installation' : DEFAULT_WARNING_DESCRIPTION

  return (
    <>
      <Tooltip title={tooltipTitle}>
        <Box component="span">
          <Button variant="contained" disabled={!canEdit} onClick={() => setEditModalOpen(true)}>
            Edit
          </Button>
        </Box>
      </Tooltip>

      <Modal
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <IntegrationModuleEditWizard
          installation={installation}
          integrationModule={integrationModule}
          onClose={() => setEditModalOpen(false)}
          onSuccess={updated => {
            onInstallationUpdated(updated)
            setEditModalOpen(false)
            toast.success('Installation updated successfully')
          }}
          onError={error => {
            setEditModalOpen(false)
            toast.error(error)
          }}
        />
      </Modal>
    </>
  )
}
